import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";
import whatsappIcon from "../assets/images/whatsapp.svg";

export const WHATSAPP_CHAT_URL = "https://wa.me/447807264147";

const WhatsAppPurchaseBanner = () => {
  const { t } = useTranslation();
  const [isDismissed, setIsDismissed] = useState(false);

  const handleClose = () => {
    setIsDismissed(true);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className="whatsapp-purchase-banner">
      <div className="whatsapp-purchase-banner__content">
        <span className="whatsapp-purchase-banner__text">
          {t("login.part21")}
        </span>
        <button
          type="button"
          className="whatsapp-purchase-banner__link"
          onClick={() => {
            window.open(WHATSAPP_CHAT_URL, "_blank");
          }}
        >
          <img
            className="whatsapp-purchase-banner__link-icon"
            src={whatsappIcon}
            alt=""
            aria-hidden="true"
          />
          {t("login.part23")}
        </button>
      </div>
      <button
        type="button"
        className="whatsapp-purchase-banner__close"
        onClick={handleClose}
        aria-label="Close WhatsApp purchase banner"
      >
        <IoClose aria-hidden="true" />
      </button>
    </div>
  );
};

export default WhatsAppPurchaseBanner;
